import { useEffect, useState } from 'react';
import { apiGet } from './api';

// Single source of truth for the free-trial date & copy. The admin edits ONE
// date in Admin → Settings → Free Trial; the backend derives every label and
// this hook fans it out to the landing page, login page, app header and nudges.

const STORAGE_KEY = 'gv_trial_copy';

const FALLBACK = {
  label: '',
  short: '',
  headline: 'Free for Every Student',
  chip: 'Free',
  banner: 'Every feature, every subject. No credit card, no commitment.',
  bannerEnabled: true,
};

function readStored() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

let cache = readStored();
let inflight = null;

function normalise(pc = {}) {
  return {
    label: pc.trial_end_label || '',
    short: pc.trial_end_short || '',
    headline: pc.trial_headline || FALLBACK.headline,
    chip: pc.trial_chip || FALLBACK.chip,
    banner: pc.trial_banner_copy || FALLBACK.banner,
    // Admin kill switch — when OFF no free-access message is shown anywhere.
    bannerEnabled: pc.trial_banner_enabled !== false,
  };
}

export async function fetchTrialCopy() {
  if (!inflight) {
    inflight = apiGet('/public/settings')
      .then(d => {
        cache = normalise(d?.payment_config);
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify(cache)); } catch { /* noop */ }
        return cache;
      })
      .catch(() => cache || FALLBACK)
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useTrialCopy() {
  const [copy, setCopy] = useState(cache || FALLBACK);
  useEffect(() => { fetchTrialCopy().then(setCopy); }, []);
  return copy;
}

/** "Free for every student until 14 Sep 2026" (date omitted when unset). */
export function untilPhrase(copy, prefix = 'Free for every student') {
  return copy?.label ? `${prefix} until ${copy.label}` : prefix;
}
